import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AccountAanmakenPage } from './features/auth/AccountAanmakenPage';
import { LoginPage } from './features/auth/LoginPage';
import { ArchivePage } from './features/archive/ArchivePage';
import { CarDetailPage } from './features/car-detail/CarDetailPage';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { FleetPage } from './features/fleet/FleetPage';
import { InvoicesPage } from './features/invoices/InvoicesPage';
import { PasDetailPage } from './features/passen/PasDetailPage';
import { PassenArchiefPage } from './features/passen/PassenArchiefPage';
import { PassenPage } from './features/passen/PassenPage';
import { PersonenArchiefPage } from './features/personen/PersonenArchiefPage';
import { PersonenPage } from './features/personen/PersonenPage';
import { PersoonDetailPage } from './features/personen/PersoonDetailPage';
import { SettingsPage } from './features/settings/SettingsPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Publiek: het token uit de uitnodigingsmail is hier het enige bewijs. */}
      <Route path="/uitnodiging/:token" element={<AccountAanmakenPage />} />
      <Route element={<ProtectedRoute />}>
        {/* Buiten `Layout`: dit zijn pagina's waar je even uit de navigatie
            stapt en met een terugpijl weer instapt. */}
        <Route path="/auto/:kenteken" element={<CarDetailPage />} />
        <Route path="/instellingen" element={<SettingsPage />} />
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="/wagenpark" element={<FleetPage />} />
          <Route path="/personen" element={<PersonenPage />} />
          <Route path="/personen/archief" element={<PersonenArchiefPage />} />
          <Route path="/personen/:id" element={<PersoonDetailPage />} />
          <Route path="/passen" element={<PassenPage />} />
          <Route path="/passen/archief" element={<PassenArchiefPage />} />
          <Route path="/passen/:id" element={<PasDetailPage />} />
          <Route path="/archief" element={<ArchivePage />} />
          <Route path="/facturen" element={<InvoicesPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
